import React, { useState } from "react";
import { MailWarning, Loader2, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success("Verification email sent — check your inbox.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send right now. Try again shortly.");
    } finally { setBusy(false); }
  };

  return (
    <div className="mb-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 p-3 rounded-xl border border-amber-500/30 bg-amber-500/10" data-testid="verify-email-banner">
      <div className="flex items-start gap-2.5 flex-1 min-w-0">
        <MailWarning className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
        <div className="text-sm">
          <span className="font-semibold">Verify your email.</span>{" "}
          <span className="text-muted-foreground">We sent a confirmation link to <span className="font-medium text-foreground">{user.email}</span>. Verifying keeps your account secure and makes sure your reminders land in your inbox.</span>
        </div>
      </div>
      {sent ? (
        <span className="flex items-center gap-1.5 text-xs font-semibold text-emerald-500 shrink-0" data-testid="verify-resent"><Check className="h-4 w-4" /> Email sent</span>
      ) : (
        <button onClick={resend} disabled={busy} data-testid="verify-resend-btn"
          className="shrink-0 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-500 text-white text-xs font-semibold hover:bg-amber-600 transition disabled:opacity-50">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Resend email"}
        </button>
      )}
    </div>
  );
}
